import { render } from "./WizardPopupComponent.vue?vue&type=template&id=1f8eb60e"
import script from "./WizardPopupComponent.vue?vue&type=script&lang=js"
export * from "./WizardPopupComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__